import * as React from 'react';
import { TableBaseProps } from '../AdminView/types';

interface AdminTableRowProps extends TableBaseProps {}
export const AdminTableRow = (props: AdminTableRowProps) => {
  const { children } = props;

  return <tr>{children}</tr>;
};
